import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import siswa from './siswa'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)


export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    siswa
  },
  plugins: [vuexLocal.plugin]
})
